import request from './request.service';
import { api } from '../config';
import { RESULT_LIMIT, MIN_PATTERN_LENGTH } from '../constants/search';

export const getLatestOpportunities = async () => {
  const response = await request(api.getLatestOpportunities, {
    method: 'GET',
  });
  return response.body;
};

export const saveLatestOpportunity = async opportunity => {
  const response = await request(api.saveLatestOpportunity, {
    method: 'POST',
    body: { opportunity },
  });
  return response.body;
};

export const findOpportunities = async search => {
  if (search === '') return { opportunities: [] };
  if (search !== '' && search.length < 3) {
    return { opportunities: [], message: { type: 'info', text: 'Please enter at least 3 letters' } };
  }

  const findOpportunitiesURL = `${api.findOpportunities}&searchString=${search}`;
  const response = await request(findOpportunitiesURL, {
    method: 'GET',
  });

  const { data, searchString, success } = response.body;
  if (!success) {
    return {
      opportunities: [],
      message: { type: 'error', text: `Couldn't get Opportunities. Please try again later.` },
    };
  }

  if (searchString === search) {
    return {
      opportunities: data,
      ...(data.length === 0 && { message: { type: 'info', text: 'Nothing Found' } }),
    };
  }
};

export const forecastFindOpportunities = async search => {
  if (search === '') return { opportunities: [] };
  if (search.length < MIN_PATTERN_LENGTH) {
    return {
      opportunities: [],
      message: { type: 'info', text: `Please enter at least ${MIN_PATTERN_LENGTH} letters` },
    };
  }

  const findOpportunitiesURL = `${api.forecastFindOpportunities}?searchString=${search}&resultsLimit=${RESULT_LIMIT}`;
  const response = await request(findOpportunitiesURL, {
    method: 'GET',
  });

  const { success, opportunities, searchString } = response.body;
  if (!success) {
    return {
      opportunities: [],
      message: { type: 'error', text: 'Opportunities search is currently not available' },
    };
  }

  if (searchString === search) {
    return {
      opportunities,
      ...(opportunities.length === 0 && { message: { type: 'info', text: 'Nothing Found' } }),
    };
  }

  return { opportunities: [], message: {} };
};
